import React, {useCallback, useEffect, useMemo, useState} from 'react';

import {BroadcastContext} from './broadcast-context';

export const BroadcastContextProvider = ({children}: {children: React.ReactNode}) => {
    const [channel, setChannel] = useState<BroadcastChannel | undefined>(undefined);

    useEffect(() => {
        const broadcastChannel = new BroadcastChannel('pb-admin-messages');
        setChannel(broadcastChannel);

        return () => {
            broadcastChannel.close();
        };
    }, []);

    const sendMessage = useCallback((data: string) => {
        if (channel) {
            channel.postMessage(data);
        }
    }, [channel]);

    const value = useMemo(() => ({sendMessage, channel}), [sendMessage, channel]);

    return (
        <BroadcastContext.Provider value={value}>
            {children}
        </BroadcastContext.Provider>
    );
};
